namespace Gordic.Adm.WebControls {
    @Decorators.gcontent
    export class GAdmTaskList extends GContentBase {
        isAuthService: boolean;

        onContentReady(): void {
            const runWithChildren = new GAction({
                name: "runWithChildren",
                run: (ev, ctx: { children: MenuParams[], icon: string, id: string, caption: string }) => {
                    ($.content("main") as any).navigateTask([
                        Gordic.Gui.WebApp.GSignpost,
                        {
                            menuParams: ctx.children,
                            uid: ctx.id,
                            cntId: ctx.id,
                            ID: ctx.id,
                            icon: ctx.icon,
                            caption: ctx.caption,
                            isAuthService: this.isAuthService,
                            addOpenInNewTab: true
                        }
                    ])
                }
            });

            $("body").on("gtasklistinternalbeforerefresh", ".gtasklist", (ev, mp: MenuParams[]) => {
                for (let i = 0; i < mp.length; i++) {
                    const p = mp[i];
                    if (p.children) {
                        p.type = "action";
                        p.action = runWithChildren;
                        p.actionContext = {
                            children: p.children,
                            icon: p.icon,
                            id: p.id,
                            caption: p.caption
                        };
                        delete p.children;
                    }
                }
            });
        }
    }
}